import React, { useState, useEffect } from "react";
import { InputOtp } from "primereact/inputotp";
import { Button } from "primereact/button";
import { Typography } from "@mui/material";
import axios from "axios";

import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import { BASE_URL, CONTACT_SUBMIT, CONTACT_VERIFY } from "../utills/ApplicationRouting";
import CommonContainer from "../components/CommonContainer";

function Otp() {
    const [timer, setTimer] = useState(30);
  const [showResend, setShowResend] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();

  const { token, contact, email } = useSelector((state) => state.qps);

  const customInput = ({ events, props }) => {
    return (
      <input
        {...events}
        {...props}
        type="text"
        className="w-12 h-10 text-2xl text-center transition-all duration-300 border-2 border-blue-300 bg-white rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1E88E5] focus:border-[#1E88E5] mx-1"
      />
    );
  };

  const handleResend = async () => {
    setTimer(30);
    setShowResend(false);

    const resendPostData = { email: email, contact: contact };
    setIsLoading(true);

    try {
      const response = await axios.post(
        `${BASE_URL}${CONTACT_VERIFY}`,
        resendPostData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        setIsLoading(false)
        console.log("OTP Resent");
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error);
      
      if (error.response && error.response.data) {
        setIsLoading(false)
        const errors = error.response.data; 
        if (typeof errors === "object") {
          setIsLoading(false)
          Object.keys(errors).forEach((key) => {
            console.log(`${errors[key]}`); 
            toast.error(`${errors[key]}`); 
          });
        } else {
          setIsLoading(false)
          toast.error(errors); 
        }
      } 
    } 
  };

  const handleSubmitOtp = async () => {
    setIsLoading(true);
    const otpData = { email: email, contact: contact, otp: otp };

    try {
      const response = await axios.post(
        `${BASE_URL}${CONTACT_SUBMIT}`,
        otpData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        console.log("OTP Verified:", response.data);
        toast.success(response.data);
        navigate("/career-form");
      }
    } catch (error) {
      setIsLoading(false)
      if (error.response && error.response.data) {
        setIsLoading(false)
        const errors = error.response.data; 
        if (typeof errors === "object") {
          setIsLoading(false)
          Object.keys(errors).forEach((key) => {
            console.log(`${errors[key]}`); 
            toast.error(`${errors[key]}`); 
          });
        } else {
          setIsLoading(false)
          toast.error(errors); 
        }
      } 
    } 
  };

  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setShowResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  return (
    <div className="w-full bg-gray-100">
  <CommonContainer>
    <div className="min-h-[80vh] flex items-center justify-center py-12">
      <Toaster/>
     
      <div className="w-full max-w-md bg-white rounded-xl shadow-lg p-8">
        <div className="text-center mb-8">
          <Typography
  variant="h6"
  align="center"
  className="font-bold"
>
  Contact Verification
</Typography>

<p className="text-gray-600 text-center mt-3">
  Please enter the verification code sent to your registered contact number.
</p>
        </div>

        {/* OTP Input */}
        <div className="flex justify-center mb-6">
          <InputOtp
            value={otp}
            onChange={(e) => setOtp(e.value)}
            length={6}
            inputTemplate={customInput}
            className="flex justify-center space-x-2"
          />
        </div>

        {/* Timer and Resend Button */}
        <div className="flex justify-between items-center mb-6">
          {timer > 0 && (
            <Typography variant="body2" className="text-sm text-gray-500">
              Resend OTP in {timer} seconds
            </Typography>
          )}
          {showResend && (
            <button
              type="button"
              onClick={handleResend}
              className="text-sm text-blue-600 hover:text-blue-800"
            >
              Resend OTP
            </button>
          )}
        </div>

        {/* Submit Button */}
        <div className="mt-6 text-center">
          <Button
  label="Submit"
  onClick={handleSubmitOtp}
  disabled={isLoading || otp.length !== 6}
  className="w-full text-sm !bg-[#153E75] hover:!bg-[#1E88E5] text-white rounded py-2"
/>
       <div className="mt-6 text-center">
        <a
  href="/"
  className="text-blue-700 text-sm hover:underline"
>
  Back to Home
</a>
<div
  className="text-gray-500 text-center mt-6"
  style={{ fontSize: "10px" }}
>
  Didn't receive the code? You can resend it after the timer expires.
</div>
        </div>
        </div>
        </div>
        </div>
       </CommonContainer>
</div>
  )
}

export default Otp
